export const LOCK_RETRY_DELAY_MS = 300;

// The backend returns 503 when it cannot take the per-item applock; one short
// retry is enough, anything else is surfaced immediately.
export function retryOnceOnLockTimeout(failureCount, error) {
  return failureCount < 1 && error?.status === 503;
}

export const lockRetryOptions = {
  retry: retryOnceOnLockTimeout,
  retryDelay: LOCK_RETRY_DELAY_MS,
};
